import { render, staticRenderFns } from "./detail-component-list.vue?vue&type=template&id=7c73b194&scoped=true"
import script from "./detail-component-list.vue?vue&type=script&lang=ts"
export * from "./detail-component-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c73b194",
  null
  
)

export default component.exports